var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}

site.maxHeight = {
	init: function (selector) {
		if (!selector || $(selector).length == 0) return;
		site.maxHeight.setHeight(selector);
		$(window).resize(function () {
			site.maxHeight.setHeight(selector);
		});
	},

	setHeight: function (selector) {
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	}
};

site.sjodir = {
	init: function() {
		$('<select id="groupMobile" />').insertAfter("#extras .groups");

		$('#groupMobile').wrap('<div class="groupMobileWrap"></div>');
		$("#extras .groups li a").each(function() {
			var el = $(this);
			var href = (el.attr("href") == '#') ? '#all' : el.attr("href");
			$("<option />", {
				"value"   : href,
				"text"    : el.text(),
				"class"   : href.substr(1,href.length)
			}).appendTo("#groupMobile");
		});
		$("#groupMobile").change(function() {
			var val = $(this).find("option:selected").val();
			location.hash = val;
			val = val.substr(1, val.length);
			$("#extras .groups").find("."+val+" a").trigger('click');
		});

		$(window).load(function() {
			var $container = $('#extras .sjodir .items');
			var b = location.hash;
			if (b) {
				b = '.'+b.substr(1, b.length);
				var $container = $('#extras .items');

				$('.groups li').removeClass('selected');
				$(".groups "+b+"").addClass('selected');
				$("#groupMobile "+b+"").attr('selected','selected');
			}
			else {
				b = '*';
			}

			mixitup($container, {
				load: {
					filter: b
				},
				selectors: {
					target:'.item'
				}
			});
		});


		$('.groups').on( 'click', 'a', function(e) {
			if ($(this).parent().hasClass('all')) {
				e.preventDefault();
				site.window.scrollPosition = $(window).scrollTop();
				location.hash = '#';
				$(window).scrollTop(site.window.scrollPosition);
			}

			$('.groups li').removeClass('selected');
			$(this).parent().addClass('selected');
		});

		$('#extras .item .hasLink').on('click',function() {
			window.location.href=$(this).find('.more').attr('href');
		});

	}
};

site.savings = {
	init: function () {
		$('button', '.toggler').on('click', (e) => {
			$(e.target).closest('tr').toggleClass('open');
		});
	}
};

site.imageCaption = {
	// display image caption on top of image
	init: function() {
		$(window).on('load', function() {
			$('#news').find(".boxText img").each(function () {
				var imageCaption = $(this).attr('title');
				if (imageCaption !== '' && imageCaption !== undefined) {
					var imgWidth = $(this).width();
					$("<span class='img-caption'><em>" + imageCaption +
						"</em></span>").css({
						'max-width': imgWidth + 'px',
						'width': '100%',
						'display': 'inline-block'
					}).insertAfter(this);
					if($(this).hasClass('mceAlignCenter')) {
						$(this.parentNode).addClass('center');
					}
				}
			});
		});
	}
};

site.faq = {
	init : function() {
		var $faq = $('#faq,#main .box_faqCategory');
		if ($faq.length == 0) return false;

		$('.answer', $faq).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});

		$(window).resize(function() {
			$('.answer', $faq).each(function() {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		});

		$faq.find('.question').click(function() {
			$(this).parent('li').toggleClass('open');
		});
		$faq.find('#cancel').click(function() {
			window.history.back();
		});

		/*
		var $faq2 = $('#main .box_fagCategory');
		$faq2.find('.question').click(function() {
			$(this).siblings().toggle();
			$(this).parent('li').toggleClass('open');
		});
		$faq2.find('#cancel').click(function() {
			window.history.back();
		});*/
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.maillist = {
	init: function() {
		if ($('.areaHidden').html().length > 4) {
			function openFancybox() {
				$.fancybox({
					'autoDimensions': false,
					'width': 650,
					'height': 350,
					'wrapCSS': 'mailchimpFancy',
					'content': $(".areaHidden").html()
				});
			}

			$(document).ready(function() {
				var visited = $.cookie('visited-ll');
				if (visited === 'yes') {
					return false;
				} else {
					openFancybox();
				}
				$.cookie('visited-ll', 'yes', {
					expires: 30
				});
			});
		}
	}
};

site.afmaeli = {
	init: function () {
		$("#ara50").fancybox({
			href: '/_/moya/page/index/index/popup-50-ara-afmaeli',
			openEasing: 'swing',
			openSpeed: 1500,
			fitToView: true,
			autoSize    : true,
			closeClick    : true,
			closeEffect    : 'fade',
			type: 'ajax'
		});


		function openFancybox() {
			$.fancybox({
				href: '/_/moya/page/index/index/popup-50-ara-afmaeli',
				openEasing: 'swing',
				openSpeed: 1500,
				fitToView: true,
				autoSize    : true,
				closeClick    : true,
				closeEffect    : 'fade',
				type: 'ajax'
			});
		}

		$(document).ready(function () {
			var visited = $.cookie('afmaeli50');
			if (visited === 'v0.3') {
				return false;
			} else {
				openFancybox();
			}
			$.cookie('afmaeli50', 'v0.3', {
				expires: 7
			});
		});
	}
};

site.hideFixedNode = {
	init: function () {
		var fixedNode = document.getElementsByClassName('ele-grof fixedNode si level2 children ord-9');
		if(fixedNode.length > 0){
			if(fixedNode[0].getElementsByClassName('hide').length > 0){
				$('.fixedNode .level3.selectedLevel3 .mmLevel4').each(function () {
					$(this).removeClass('hide');
				});
			}
		}
	}
};

site.frontpage = {
	init: function() {
		$('.b-3 > li', '#accordion').on('hover', function(e) {
			e.preventDefault();
			var $this = $(this);
			//var $li = $this.closest('li');
			if(!$this.hasClass('open')) {
				$('.open', '#accordion').removeClass('open').addClass('close');
				$this.removeClass('close').addClass('open');

				setTimeout(function() {
					$this.addClass('opened');
				}, 400);
			}
			if(e.type == 'mouseleave' && $this.hasClass('open')) {
				$this.removeClass('open').removeClass('opened').addClass('close');
			}

			/*
			$(this).parents('#accordion').addClass('opened');
			$('.open', '#accordion').addClass('closing').removeClass('open');
			$this.closest('li').addClass('opening');
			*/

			/*setTimeout(function() {
				$('.closing', '#accordion').removeClass('closing');
				$this.closest('li').addClass('open').removeClass('opening');
			},500);*/
		});

		$('p a', '#accordion').each(function() {
			$(this).parent().addClass('hasLink');
		});

		if ($('body').width()+15 < 768) {
			$('#accordion li.open').removeClass('open').removeClass('opened');
		}

		$('a.scroll').on('click', function(e){
			e.preventDefault();
			$('html,body').animate({scrollTop:$(this).offset().top}, 500);
		});
	}
};

site.qn = {
	init: function() {
		var $body = $('body'),
			$qnChildren = $('.mmLevel1 .children', '#qn');
		$('.level2 a', $qnChildren).each(function() {
			$(this).html($(this).html().replace(' | ', '</span><span>'));
		});
		$('.mmLevel2', $qnChildren).removeClass('hide');

		if ($body.width() + 15 >= 992) {
			$('> a', $qnChildren).on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				$('body').toggleClass('qn-open');

				$('body.qn-open').on('click', function (e) {
					site.qn.close();
				});
			});
		}

		var $qnNext = $('.qn.children').next();
		$qnNext.find('a').on('focus', function(e) {
			if ($body.hasClass('qn-open')) {
				site.qn.close();
			}
		});

		$(document).keydown(function (e) {
			if (e.which === 27 && $body.hasClass('qn-open')) {
				site.qn.close();
				var $level1 = $(e.target).closest('.level1');
				$('> a', $level1).focus();
			}
		});

		site.qn.appendQuickNav();
	},

	appendQuickNav: function () {
		var $qn = $('#qn');
		var $menu = $('.mm-listview', '#mm-1');
		var $qnContent = '';

		$qn.find('li.level1').each(function () {
			var classes = $(this).attr('class');
			$qnContent += '<li class="qn ' + classes + '">' + $(this).clone().html() + '</li>';
		});
		$menu.append($qnContent);
		$('.qn .mmLevel2', $menu).removeAttr('id');
	},

	close: function() {
		$('.open', '#qn').removeClass('open');
		$('body').removeClass('qn-open');
	}
};

site.translate = {
	// LLIS-138
	// Provide site translator with $selectors which will be translated.
	// All elements except for $selectors will remain untranslated.
	init: function($divisionSelector, $translateSelectors) {

		var $body = $('body');

		if (!$body.is($divisionSelector) || $body.is('.admin')) {
			return;
		}

		$translateSelectors = $translateSelectors.join(', ');
		$($translateSelectors).each(function() {
			$(this).addClass('translate');
		})
	}
};

site.highcharts = {
	init: function () {
		$chart = $('#preview div');
		if ($chart.length > 0) {;
			setTimeout(() => {
				$chart[0].style.maxHeight = `${$chart[0].offsetHeight}px`;
			}, 500)
		}
	}
}

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.faq.init();
	if ($('body').is('.frontpage')) {
		site.frontpage.init();
	}
	else {
		site.imageCaption.init();
	}

	if ($('body').is('.highcharts')) {
		site.highcharts.init();
	}

	$('[rel=tooltip]').tooltip({container: 'body'});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table:not(.data)', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	site.qn.init();
	//site.maillist.init();

	site.translate.init(
		'.pl',
		[
			'#heroVidtol',
			'#abendingar',

			'body.news .pageTitle',
			'#news',
			'.box_newsheadlinesSidebar',

			'body.newsarchive .pageTitle',
			'#newsarchive',

			'.socialShare',

			'.faqNews'
		]
	);
	//site.afmaeli.init();
	site.hideFixedNode.init();
	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

MoyaComponents.register('site.fancybox', [
	'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css',
	'https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js',
], () => {
	Fancybox.bind('[data-fancybox]', {
		groupAll: true,
	});
});
